import React, { useEffect, useState } from 'react';
import { WizardContent } from '../../components/WizardContent';
import { WizardTitle } from '../../components/WizardTitle';
import WizardButton from '../../components/WizardButton';
import { Form } from './DocumentType.styles';
import { useWizardRequest } from '../../../../hooks/services/useWizardRequest';
import ITypeDocument from '../../../../interfaces/ITypeDocument';
import IMedicalCertificate from '../../../../interfaces/IMedicalCertificate';
import IWizardStep from '../../../../interfaces/IWizardStep';
import { useLocalStorage } from '../../../../hooks/providers/useLocalStorage';
import { StyledAlert } from '../../components/ErrorMessage';
import {
  Alert,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from '@mui/material';
import { ShowError } from '../tenantDomain/TenantDomain.styles';
import { useSystemInformationService } from '../../../../hooks/services/useSystemInformationService';
import { ITenantConfig } from '../../../../interfaces/ITenantConfig';
import CompanionDialog from './CompanionDialog';

interface DocumentTypeProps extends IWizardStep { }

const DocumentType = (props: DocumentTypeProps) => {
  const [loading, setLoading] = useState(false);
  const [typeDocuments, setTypeDocuments] = useState<ITypeDocument[]>([]);
  const [typeDocumentId, settypeDocumentId] = useState<number | undefined>(undefined);
  const [, setMedicalCertificate] = useState<IMedicalCertificate | null>(props.medicalCertificate);
  const [systemInformation, setSystemInformation] = useState<ITenantConfig>();
  const [error, setError] = useState<string | null>(null);
  const [companionDialogOpen, setCompanionDialogOpen] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState<ITypeDocument | undefined>(undefined);

  const wizardService = useWizardRequest();
  const systemInformationService = useSystemInformationService();
  const localStorage = useLocalStorage();

  const handleCheckTypeDocument = (id: number | undefined) => {
    settypeDocumentId(id);
  };

  const loadTypeDocuments = async () => {
    const queryParams = `perPage=200&currentPage=1&orderBy=description&orderDirection=asc`;
    await wizardService
      .listTypeDocuments(queryParams)
      .then(response => {
        setTypeDocuments(response.data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    if (!typeDocumentId) {
      setError('Selecione um tipo de documento para continuar.');
      setLoading(false);
      return;
    }
    const documentType = typeDocuments.find(d => d.id === typeDocumentId);

    if (!documentType) {
      setError('Tipo de documento inválido. Selecione novamente para continuar.');
      return;
    }

    setSelectedDocumentType(documentType);
    localStorage.setItem('documentType', documentType);

    if (documentType.hasCompanion) {
      setCompanionDialogOpen(true);
      return;
    }

    await proceedToNextStep(documentType);
  };

  const proceedToNextStep = async (
    documentType: ITypeDocument | undefined,
    companionData?: {
      companionName: string;
      companionRelationship: string;
      companionAge: number | '';
    },
  ) => {
    await props.setStep(
      props.step + 1,
      {
        ...props.medicalCertificate,
        typeDocumentId: typeDocumentId || 0,
        typeDocument: documentType || undefined,
        ...(companionData && {
          companionName: companionData.companionName,
          companionRelationship: companionData.companionRelationship,
          companionAge: companionData.companionAge === '' ? undefined : Number(companionData.companionAge),
        }),
      },
      props.step,
    );
    setLoading(false);
  };

  const handleCompanionConfirm = async (data: {
    companionName: string;
    companionRelationship: string;
    companionAge: number | '';
  }) => {
    setCompanionDialogOpen(false);
    await proceedToNextStep(selectedDocumentType, data);
  };

  const Loadtenant = async () => {
    const localSettings = localStorage.getItem('localSettings');
    const tenantDomain = localSettings?.tenantDomain;
    await systemInformationService
      .listTenantConfig(tenantDomain)
      .then(response => {
        setSystemInformation(response);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    setMedicalCertificate(props.medicalCertificate);
    loadTypeDocuments();
    Loadtenant();
  }, []);

  return (
    <WizardContent>
      <WizardTitle>Selecione o tipo de documento:</WizardTitle>
      <Form onSubmit={handleSubmit}>
        {systemInformation?.documentTypeDisplayMode &&
          (systemInformation?.documentTypeDisplayMode === 1 ? (
            <>
              {typeDocuments.length > 0 && (
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={undefined}
                  name="radio-buttons-group"
                >
                  {typeDocuments.map(typeDocument => {
                    return (
                      <FormControlLabel
                        key={typeDocument.id}
                        value={typeDocument.id}
                        control={
                          <Radio
                            onChange={() => {
                              handleCheckTypeDocument(typeDocument.id);
                            }}
                            sx={{
                              color: 'rgb(32, 144, 136)',

                              '&.Mui-checked': {
                                color: 'rgb(32, 144, 136)',
                              },
                            }}
                          />
                        }
                        label={typeDocument.description}
                      />
                    );
                  })}
                </RadioGroup>
              )}
            </>
          ) : (
            <Grid item md={3} sm={2} xs={12} width={250}>
              <FormControl fullWidth size="small">
                <InputLabel id="professional-state">Tipo de documento</InputLabel>
                <Select
                  labelId="Tipo de documento"
                  type="number"
                  id="document-type"
                  value={typeDocumentId}
                  label="Informe a Situação"
                  onChange={e => handleCheckTypeDocument(Number(e.target.value))}
                  MenuProps={{
                    sx: { maxHeight: '500px' },
                    PaperProps: {
                      style: {
                        maxHeight: 320,
                      },
                    },
                  }}
                >
                  {typeDocuments?.map((documentType, i) => {
                    return (
                      <MenuItem value={documentType.id} key={i}>
                        {documentType.description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              {typeDocuments.map(typeDocument => {
                if (typeDocument.id === typeDocumentId && typeDocument.additionalText) {
                  return (
                    <div style={{ marginTop: 40 }} key={typeDocument.id}>
                      <ShowError show={true}>
                        <Alert severity="info">{typeDocument.additionalText}</Alert>
                      </ShowError>
                    </div>
                  );
                }
                return null;
              })}
            </Grid>
          ))}
        <br />

        {error && (
          <div>
            <ShowError show={error !== null}>
              <StyledAlert severity="error">{error}</StyledAlert>
            </ShowError>
          </div>
        )}
        <WizardButton type="submit" isLoading={loading} disabled={loading} sx={{ marginTop: '35px' }}>
          PRÓXIMO
        </WizardButton>
      </Form>
      <CompanionDialog
        isOpen={companionDialogOpen}
        onClose={() => setCompanionDialogOpen(false)}
        onConfirm={handleCompanionConfirm}
      />
    </WizardContent>
  );
};

export default DocumentType;
